import gql from 'graphql-tag';

const confirmFlatRateOfferBatchMutation = gql`
  mutation confirmFlatRateOfferBatch($input: ConfirmFlatRateOfferBatchInput!) {
    confirmFlatRateOfferBatch(input: $input) {
      success
      errors
    }
  }
`;

export default confirmFlatRateOfferBatchMutation;
